<template>
  <div>
    <error slot="description" :errors="errors"/>
    <success :success="success"/>

    <md-field class="md-form-group" slot="inputs" v-for="(input, key) in updatePassword" :key="key">
      <md-icon>{{ input.icon }}</md-icon>
      <label>{{ input.label }}</label>
      <md-input v-model="input.value" :type="input.type" :disabled="input.disabled"></md-input>
    </md-field>

    <md-button class="md-warning" @click="changePassword()">Изменить</md-button>
  </div>
</template>

<script>

import Error from "./Error";
import Success from "./Success";
import {mapActions} from "vuex";
export default {
  name: "ChangePassword",
  components: {Success, Error},
  data(){
    return {
      updatePassword: {
        now_password: {
          label: 'Ваш текущий пароль',
          value: '',
          type: 'password',
          icon: 'password',
          disabled: false
        },
        new_password: {
          label: 'Новый пароль',
          value: '',
          type: 'password',
          icon: 'password',
          disabled: false
        },
        confirm_password: {
          label: 'Повторите пароль',
          value: '',
          type: 'password',
          icon: 'password',
          disabled: false
        }
      },
      errors: null,
      success: null
    }
  },
  methods: {
    ...mapActions(["account/changePassword"]),
    changePassword() {
      let now_password = this.updatePassword.now_password.value;
      let password = this.updatePassword.new_password.value;
      let password_confirmation = this.updatePassword.confirm_password.value;
      this.$store.dispatch('account/changePassword', { now_password, password, password_confirmation})
          .then((success) => {
            this.errors = null;
            this.success = [
              success
            ]
          })
          .catch(err => {
            this.errors = [];
            if(err.message === 'The given data was invalid.') {
              for (let i in err.errors) {
                for (let j in err.errors[i]) {
                  this.errors.push(err.errors[i][j]);
                }
              }
            } else this.errors = err
          })
    }
  },
}

</script>

<style scoped>

</style>